<div class="sw-cms-block-moorl-interactive-slider">
    <div class="sw-cms-block-moorl-interactive-slider-config">
        <mt-button
            variant="secondary"
            size="default"
            @click="showConfigurationModal = true"
        >
            {{ $tc('global.default.edit') }}
        </mt-button>
        <mt-button
            variant="secondary"
            size="default"
            @click="addSlot()"
        >
            {{ $tc('global.default.add') }}
        </mt-button>
        <mt-button
            variant="secondary"
            size="default"
            @click="removeSlot()"
        >
            {{ $tc('global.default.delete') }}
        </mt-button>
        <moorl-select-field
            v-model:value="activeSlot"
            :customSet="block.slots"
            variant="small"
            valueProperty="id"
            labelProperty="slot"
        />
    </div>
    <div
        class="sw-cms-block-moorl-interactive-slider-content"
        ref="content"
    >
        <template v-for="slot in block.slots">
            <div
                v-if="slot.id === activeSlot"
                :style="slotStyle"
                class="sw-cms-block-moorl-interactive-slider-slot"
            >
                <slot :name="slot.slot"/>
            </div>
        </template>
    </div>
    <sw-modal
        v-if="showConfigurationModal"
        :title="$tc('sw-cms.blocks.moorl-slider.interactive')"
        @modal-close="showConfigurationModal = false"
    >
        <sw-container
            columns="1fr 1fr"
            gap="0px 30px"
        >
            <mt-text-field
                v-model="block.customFields.moorl_interactive_slider.itemWidth"
                :label="$tc('moorl-foundation.field.itemWidth')"
            />
            <mt-text-field
                v-model="block.customFields.moorl_interactive_slider.itemHeight"
                :label="$tc('moorl-foundation.field.itemHeight')"
            />
            <mt-text-field
                v-model="block.customFields.moorl_interactive_slider.gapSize"
                :label="$tc('moorl-foundation.field.gapSize')"
            />
            <mt-number-field
                v-model="block.customFields.moorl_interactive_slider.speed"
                :label="$tc('moorl-foundation.field.speed')"
            />
            <mt-number-field
                v-model="block.customFields.moorl_interactive_slider.autoplayTimeout"
                :label="$tc('moorl-foundation.field.autoplayTimeout')"
            />
            <mt-switch
                v-model="block.customFields.moorl_interactive_slider.autoplay"
                bordered
                :label="$tc('moorl-foundation.field.autoplay')"
            />
            <mt-switch
                v-model="block.customFields.moorl_interactive_slider.autoplayHoverPause"
                bordered
                :label="$tc('moorl-foundation.field.autoplayHoverPause')"
            />
            <mt-switch
                v-model="block.customFields.moorl_interactive_slider.navigation"
                bordered
                :label="$tc('moorl-foundation.field.navigation')"
            />
            <moorl-select-field
                v-model:value="block.customFields.moorl_interactive_slider.animateIn"
                set="animateIn"
            />
            <moorl-select-field
                v-model:value="block.customFields.moorl_interactive_slider.animateOut"
                set="animateOut"
            />
        </sw-container>
    </sw-modal>
</div>